import { SocieteComposantFamilleSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocieteComposantFamilleModel: SelectorModel = {
  name: 'societeComposantFamilles',
  getSelector: SocieteComposantFamilleSelectors.selectAllSocieteComposantFamillesDictionary,
  isReady: SocieteComposantFamilleSelectors.selectIsReadySocieteComposantFamille
};
